import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { formatMoney } from "../../lib/format";

const short = (n, d) => n.toFixed(d).replace(/\.0$/, "");
const compact = (v) => {
  const a = Math.abs(v);
  if (a >= 1e9) return `$${short(v / 1e9, a >= 1e10 ? 0 : 1)}B`;
  if (a >= 1e6) return `$${short(v / 1e6, a >= 1e7 ? 0 : 1)}M`;
  if (a >= 1e3) return `$${Math.round(v / 1e3)}K`;
  return `$${v}`;
};

const Tip = ({ active, payload, label }) =>
  active && payload?.length ? (
    <div className="rounded-xl border border-[#dfe7f3] bg-white px-3 py-2 shadow-lg" data-testid="chart-tooltip">
      <div className="text-xs font-semibold text-[#5b667a]">{label}</div>
      <div className="text-sm font-extrabold text-[#182235]">{formatMoney(payload[0].value)}</div>
    </div>
  ) : null;

const axis = { tick: { fill: "#5b667a", fontSize: 11 }, tickLine: false, axisLine: false };

const ChartCard = ({ title, testId, children }) => (
  <section className="tr-card tr-fade-up min-w-0 p-4 sm:p-6" data-testid={testId}>
    <h2 className="mb-4 text-base font-bold text-[#182235] md:text-lg">{title}</h2>
    <div className="h-[240px] sm:h-[280px]">
      <ResponsiveContainer width="100%" height="100%">{children}</ResponsiveContainer>
    </div>
  </section>
);

export const PortfolioCharts = ({ months }) => {
  const xProps = { dataKey: "label", ...axis, minTickGap: 18, interval: "preserveStartEnd" };
  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <ChartCard title="Portfolio Balance (end of month)" testId="chart-balance">
        <AreaChart data={months} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="balFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0f5ef7" stopOpacity={0.28} />
              <stop offset="100%" stopColor="#0f5ef7" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#e8eef7" vertical={false} />
          <XAxis {...xProps} />
          <YAxis {...axis} width={52} tickFormatter={compact} />
          <Tooltip content={<Tip />} cursor={{ stroke: "#9bb7e8", strokeDasharray: "4 4" }} />
          <Area type="monotone" dataKey="balance" stroke="#0f5ef7" strokeWidth={2.5} fill="url(#balFill)" activeDot={{ r: 5 }} isAnimationActive={false} />
        </AreaChart>
      </ChartCard>
      <ChartCard title="Interest Collected (excl. VAT)" testId="chart-interest">
        <BarChart data={months} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#e8eef7" vertical={false} />
          <XAxis {...xProps} />
          <YAxis {...axis} width={52} tickFormatter={compact} />
          <Tooltip content={<Tip />} cursor={{ fill: "#eef4ff" }} />
          <Bar dataKey="interest" fill="#14b8a6" radius={[4, 4, 0, 0]} maxBarSize={28} isAnimationActive={false} />
        </BarChart>
      </ChartCard>
    </div>
  );
};
